import styled from "styled-components";

const LeftBarContainer = styled.div`
    width: 100%;

    @media (min-width: 768px) {
        width: 300px;
        position: sticky;
        top: 5px;
    }

    .link-container {
        border-top: 1px solid #ddd;
        border-bottom: 1px solid #ddd;
        margin-bottom: -1px;
        > a {
            padding: 16px 15px 17px;
            color: #333;
            transition: 0.2s;
            &:hover,
            &.active {
                color: #000;
                background-color: #efefef;
            }
        }

        .dropdown {
            margin-top: 5px;
            margin-bottom: 15px;
            .link {
                padding-left: 25px;
                &:not(:last-child) {
                    margin-bottom: 15px;
                }
                >a {
                    color: #333;
                    &:hover {
                        color: #000;s
                    }
                }
            }
        }
    }
`;

export { LeftBarContainer };
